module.exports = __webpack_public_path__ + "static/media/g3.07971e15.png";